import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDataFusionLocationCrossReference extends Layout {
    sourceEdiStop: DataSource;
    tableXref: Table;
}
